<template>
    <div>
        <first />
        <second />
        <third />
        <fourth />
    </div>
</template>

<script src="./careers.js"></script>
<style src="./careers.css"></style>